// extracted by mini-css-extract-plugin
export default {"card":"onlylogocard_card__Xk4kR","bg":"onlylogocard_bg__g8Zzt","rewards":"onlylogocard_rewards__VcTkF","small":"onlylogocard_small__cnl8K"};